import { Slide } from "@jelly/lesson";
import config from "appConfig";
import theory from "../../theory";

const principle: Slide = {
  title: "Airborne sound insulation - Apparent sound reduction index",
  description:
    "Apparent sound reduction index in one third octave bands for 1st and 2nd source position and averaged value. It is visible that when averaging more weights is on the lower value.",
  theory: theory,
  layout: {
    type: "simple",
    options: {
      components: {
        variant: "blockContainer",
        data: {
          block: {
            type: "image",
            options: {
              src: `${config.ASSETS_URL}/05/22/principle/principle-5.svg`,
            },
          },
        },
      },
    },
  },
};

export default principle;
